import { LayoutsHome } from "../layouts";
import { CustomLayout } from "../components/layouts";

import { ProductPage } from "../modules/modules.logistics/pages.logistics/ProductPage";
import { ProductBrandPage } from "../modules/modules.logistics/pages.logistics/ProductBrandPage";
import { WarehousePage } from "../modules/modules.logistics/pages.logistics/WarehousePage";
import { InventoryPage } from "../modules/modules.logistics/pages.logistics/InventoryPage";
import { MerchandisePage } from "../modules/modules.logistics/pages.logistics/MerchandisePage";
import { MatrixPage } from "../modules/modules.logistics/pages.logistics/MatrixPage";

const routesLOGISTICS = [
  {
    path: "/logistics/products",
    layout: CustomLayout,
    component: ProductPage,
  },
  {
    path: "/logistics/product_brands",
    layout: CustomLayout,
    component: ProductBrandPage,
  },
  {
    path: "/logistics/warehouses",
    layout: CustomLayout,
    component: WarehousePage,
  },
  {
    path: "/logistics/inventories",
    layout: CustomLayout,
    component: InventoryPage,
  },
  {
    path: "/logistics/merchandises",
    layout: CustomLayout,
    component: MerchandisePage,
  },
  {
    path: "/logistics/matrix",
    layout: CustomLayout,
    component: MatrixPage,
  },
];
export default routesLOGISTICS;
